// ─────────────────────────────────────────────────────────────────────────────
// Utilitários de TEXTO partilhados (lean ⇄ HQ). Aqui só entra o que é REALMENTE
// cross-app — `stripMd` é: a diretiva "Hexis sem markdown" vale nas DUAS
// superfícies (app e consola), e o cérebro do Hexis é o mesmo. NB: `initials`
// NÃO vive aqui — só o lean o usa, por isso é um util do lean, não da fronteira.
// ─────────────────────────────────────────────────────────────────────────────

/** Hexis sem markdown (diretiva): limpa a resposta para texto plano legível. */
export function stripMd(input: string): string {
  return String(input ?? '')
    .replace(/```[\s\S]*?```/g, '')          // blocos de código
    .replace(/`([^`]+)`/g, '$1')             // inline code
    .replace(/\*\*([^*]+)\*\*/g, '$1')       // bold
    .replace(/\*([^*]+)\*/g, '$1')           // italic
    .replace(/^#{1,6}\s+/gm, '')             // headings
    .replace(/^\s*[-*+]\s+/gm, '• ')         // bullets
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // links → texto
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
